//const BtnDotMenu = document.querySelector('.burger');
const BtnDotMenu = document.getElementById('burger');

const DotMenu = document.querySelector('.dot-menu');
const ToggleDotMenu = function() {
  DotMenu.classList.toggle('dot-menu-open');
}
const ToggleBtnDotMenu = function() {
  BtnDotMenu.classList.toggle('exit');
}

BtnDotMenu.addEventListener('click', function(e) {
  ToggleDotMenu();
  ToggleBtnDotMenu();
});

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".dropmenu-a").forEach(el => {
    el.addEventListener('click', function () {
      document.querySelectorAll(".dropmenu-a").forEach(e => {
        if (e != this) {
          if (e.classList.contains('dropmenu-active')) e.classList.remove('dropmenu-active');
          if (e.nextElementSibling.classList.contains("submenu-show")) {
            e.nextElementSibling.classList.remove('submenu-show');
            e.parentNode.classList.remove('active');
          }
        }
      }, this);
      this.classList.toggle('dropmenu-active');
      this.nextElementSibling.classList.toggle('submenu-show');
      this.parentNode.classList.toggle('active');
    });
  });

  document.addEventListener('click', function (event) {
    const isClickInsideDotMenu = DotMenu.contains(event.target);
    const isClickInsideDropmenuActive = event.target.classList.contains('dropmenu-active');
    const isClickOnBtnDotMenu = event.target === BtnDotMenu || event.target.closest('.burger') === BtnDotMenu;
    if (!isClickInsideDotMenu && !isClickInsideDropmenuActive && !isClickOnBtnDotMenu) {
      DotMenu.classList.remove('dot-menu-open');
      document.querySelectorAll('.dropmenu-active').forEach(function (el) {
        el.classList.remove('dropmenu-active');
      });
      document.querySelectorAll('.submenu-show').forEach(function (el) {
        el.classList.remove('submenu-show');
        el.parentNode.classList.remove('active');
      });
    }
  });

  const menuLink = DotMenu.querySelectorAll("a[href*='#']");
  for (let i = 0; i < menuLink.length; i++) {
    menuLink[i].addEventListener('click', function(e) {
      DotMenu.classList.remove('dot-menu-open');
      BtnDotMenu.classList.toggle('exit');
    });
  }
});

